<div class="offcanvas-header">
    <h5 class="offcanvas-title">Staff</h5>
    <button type="button" class="btn-close text-reset" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="offcanvas-body">
    <ul ngbNav #nav="ngbNav" class="c-nav c-nav-underline">
        <li ngbNavItem>
            <button ngbNavLink>Staff List</button>
            <ng-template ngbNavContent>
                <ng-container *ngTemplateOutlet="staffList"></ng-container>
            </ng-template>
        </li>
        <li ngbNavItem>
            <button ngbNavLink>Staff Map</button>
            <ng-template ngbNavContent>
                <ng-container *ngTemplateOutlet="staffMap"></ng-container>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>

    <ng-template #staffList>
        <div class="my-3">
            <sf-input label="Search Staff" [formControl]="search" [placeholder]="searchPlaceholder()"></sf-input>
        </div>

        @for (staff of filteredStaff(); track staff.id) {
            <sf-staff-detail
                [staff]="staff"
                (sendPushNotificationOpened)="activeOffcanvas.close()"
                class="mb-2"></sf-staff-detail>
        }
    </ng-template>

    <ng-template #staffMap>
        @if (staffTracks$ | async; as tracks) {
            @if (markers.length) {
                <div class="staff-map">
                    <hr />
                    <google-map mapId="staff-map" width="100%" height="300px" [center]="center" [zoom]="zoom">
                        @for (m of markers; track m) {
                            <map-advanced-marker
                                #advancedMarker="mapAdvancedMarker"
                                [position]="m.position"
                                [options]="m.marker"
                                (mapClick)="openInfoWindow(m)"></map-advanced-marker>
                            <!-- <map-marker
                            #marker="mapMarker"
                            [position]="m.position"
                            [options]="m.marker"
                            (mapClick)="openInfoWindow(marker)"></map-marker> -->
                        }
                        <map-info-window></map-info-window>
                    </google-map>
                </div>
            }
        }
    </ng-template>
</div>
<div class="offcanvas-footer">
    <div class="d-grid gap-2">
        <button sfButton type="button" color="danger" size="lg" (click)="close()">Close</button>
    </div>
</div>
